import ViewPdirTable from "./ViewPdirTable";
export default ViewPdirTable;
